import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export default function StickyCallButton() {
    const [show, setShow] = useState(false);
    const [cookieVisible, setCookieVisible] = useState(false);

    useEffect(() => {
        const checkCookie = () => {
            const choice = localStorage.getItem("alpen_cookie_consent");
            setCookieVisible(!choice);
        };
        checkCookie();
        window.addEventListener("alpen:cookie-consent", checkCookie);
        const onScroll = () => setShow(window.scrollY > 480);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("alpen:cookie-consent", checkCookie);
        };
    }, []);

    if (!show) return null;

    return (
        <a
            href={`tel:${COMPANY.phoneTel}`}
            aria-label="Jetzt anrufen"
            data-testid="sticky-mobile-call-button"
            className={`fixed right-4 z-40 lg:hidden inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#2EA8FF] text-[#07090C] btn-glow pulse-ring transition-[bottom] duration-300 ${
                cookieVisible ? "bottom-[150px]" : "bottom-6"
            }`}
        >
            <Phone className="h-6 w-6" />
        </a>
    );
}
